import { request } from '@umijs/max';

export async function fetchCurrentUser(): Promise<API.CurrentUser> {
  return request<API.CurrentUser>('/api/users/me', {
    method: 'GET',
  });
}

export async function login(body: {
  username: string;
  password: string;
}): Promise<API.CurrentUser> {
  return request<API.CurrentUser>('/api/auth/login', {
    method: 'POST',
    data: body,
  });
}

export async function createGuestSession(): Promise<API.CurrentUser> {
  return request<API.CurrentUser>('/api/auth/guest-session', {
    method: 'POST',
  });
}

export async function logout(): Promise<API.MessageResponse> {
  return request<API.MessageResponse>('/api/auth/logout', {
    method: 'POST',
  });
}

export async function changePassword(body: {
  current_password: string;
  new_password: string;
}): Promise<API.CurrentUser> {
  return request<API.CurrentUser>('/api/auth/change-password', {
    method: 'POST',
    data: body,
  });
}

export async function requestPasswordReset(body: {
  username_or_email: string;
}): Promise<API.MessageResponse> {
  return request<API.MessageResponse>('/api/auth/password-reset/request', {
    method: 'POST',
    data: body,
    skipErrorHandler: true,
  });
}

export async function validatePasswordResetToken(body: {
  token: string;
}): Promise<API.MessageResponse> {
  return request<API.MessageResponse>('/api/auth/password-reset/validate', {
    method: 'POST',
    data: body,
    skipErrorHandler: true,
  });
}

export async function confirmPasswordReset(body: {
  token: string;
  new_password: string;
}): Promise<API.MessageResponse> {
  return request<API.MessageResponse>('/api/auth/password-reset/confirm', {
    method: 'POST',
    data: body,
    skipErrorHandler: true,
  });
}
